import { render, staticRenderFns } from "./technologyWidge.vue?vue&type=template&id=34b4eb9a&scoped=true"
import script from "./technologyWidge.vue?vue&type=script&lang=js"
export * from "./technologyWidge.vue?vue&type=script&lang=js"
import style0 from "./technologyWidge.vue?vue&type=style&index=0&id=34b4eb9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b4eb9a",
  null
  
)

export default component.exports